const sampleAssets = [
  {
    id: 1,
    title: 'Social Promo',
    image:
      'https://storage.googleapis.com/brands-public-assets/content-lab/Onboarding/Sample%20Assets/CL-SampleVideo-SocialPromo.png',
    video:
      'https://storage.googleapis.com/brands-public-assets/content-lab/Onboarding/Sample%20Assets/CL-SampleVideo-SocialPromo.mp4',
    fileName: 'CL-SampleVideo-SocialPromo.mp4',
    positionCorrection: undefined,
  },
  {
    id: 2,
    title: 'Podcast',
    image:
      'https://storage.googleapis.com/brands-public-assets/content-lab/Onboarding/Sample%20Assets/CL-SampleVideo-Podcast.png',
    video:
      'https://storage.googleapis.com/brands-public-assets/content-lab/Onboarding/Sample%20Assets/CL-SampleVideo-Podcast.mp4',
    fileName: 'CL-SampleVideo-Podcast.mp4',
    positionCorrection: undefined,
  },
  {
    id: 3,
    title: 'Commercial',
    image:
      'https://storage.googleapis.com/brands-public-assets/content-lab/Onboarding/Sample%20Assets/CL-SampleVideo-Commercial.png',
    video:
      'https://storage.googleapis.com/brands-public-assets/content-lab/Onboarding/Sample%20Assets/CL-SampleVideo-Commercial.mp4',
    fileName: 'CL-SampleVideo-Commercial.mp4',
    positionCorrection: undefined,
  },
  {
    id: 4,
    title: 'Tutorial',
    image:
      'https://storage.googleapis.com/brands-public-assets/content-lab/Onboarding/Sample%20Assets/CL-SampleVideo-Tutorial.png',
    video:
      'https://storage.googleapis.com/brands-public-assets/content-lab/Onboarding/Sample%20Assets/CL-SampleVideo-Tutorial.mp4',
    fileName: 'CL-SampleVideo-Tutorial.mp4',
    positionCorrection: '90%',
  },
  {
    id: 5,
    title: 'Testimonial',
    image:
      'https://storage.googleapis.com/brands-public-assets/content-lab/Onboarding/Sample%20Assets/CL-SampleVideo-Testimonial.png',
    video:
      'https://storage.googleapis.com/brands-public-assets/content-lab/Onboarding/Sample%20Assets/CL-SampleVideo-Testimonial.mp4',
    fileName: 'CL-SampleVideo-Testimonial.mp4',
    positionCorrection: '90%',
  },
  {
    id: 6,
    title: 'Course Video',
    image:
      'https://storage.googleapis.com/brands-public-assets/content-lab/Onboarding/Sample%20Assets/CL-SampleVideo-CourseVideo.png',
    video:
      'https://storage.googleapis.com/brands-public-assets/content-lab/Onboarding/Sample%20Assets/CL-SampleVideo-CourseVideo.mp4',
    fileName: 'CL-SampleVideo-CourseVideo.mp4',
    positionCorrection: undefined,
  },
];

export default sampleAssets;
